import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import AppPage from "./pages/AppPage";
import Events from "./pages/Events";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Shop from "./pages/Shop";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Cookies from "./pages/Cookies";
import About from "./pages/About";
import PaymentSuccess from "./pages/PaymentSuccess";
import FAQ from "./pages/FAQ";

// Explore Pages
import ExploreHub from "./pages/explore/ExploreHub";
import ExploreNews from "./pages/explore/ExploreNews";
import ExploreMusic from "./pages/explore/ExploreMusic";
import ExploreVideos from "./pages/explore/ExploreVideos";
import ExploreMovies from "./pages/explore/ExploreMovies";
import ExploreBooks from "./pages/explore/ExploreBooks";
import ExploreLegalVault from "./pages/explore/ExploreLegalVault";
import ExploreTimeline from "./pages/explore/ExploreTimeline";
import ExploreTour from "./pages/explore/ExploreTour";
import ExploreCommunity from "./pages/explore/ExploreCommunity";

function SiteContent() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        {/* Explore Routes */}
        <Route path="/explore" element={<ExploreHub />} />
        <Route path="/explore/news" element={<ExploreNews />} />
        <Route path="/explore/music" element={<ExploreMusic />} />
        <Route path="/explore/videos" element={<ExploreVideos />} />
        <Route path="/explore/movies" element={<ExploreMovies />} />
        <Route path="/explore/books" element={<ExploreBooks />} />
        <Route path="/explore/legal-vault" element={<ExploreLegalVault />} />
        <Route path="/explore/timeline" element={<ExploreTimeline />} />
        <Route path="/explore/tour-locations" element={<ExploreTour />} />
        <Route path="/explore/community" element={<ExploreCommunity />} />
      </Routes>
      <Footer />
      <CookieConsent />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SiteContent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
